import { Children, Key, useEffect } from "react";

import { InputChoicesContextProvider } from "./contexts/InputChoicesContext";

import { useControlled } from "@/hooks/useControlled/useControlled";

import { InputChoicesProps, StyledFlex } from ".";

export function InputChoices<Value extends Key = Key>({
  children,
  value,
  onChange,
  mode,
  "data-test": dataTest = "input-choices-wrapper",
  ...props
}: InputChoicesProps<Value>) {
  const [inputValue, setInputValue] = useControlled(value, null, onChange);

  // Validate that we have exactly 2 children if mode is binary.
  useEffect(() => {
    if (Children.count(children) !== 2 && mode === "binary") {
      throw new Error(
        "If mode is binary, InputChoices must have exactly 2 children."
      );
    }
  }, [mode, children]);

  return (
    <InputChoicesContextProvider
      value={inputValue}
      onChange={setInputValue}
      mode={mode}
    >
      <StyledFlex data-test={dataTest} flex={1} {...props}>
        {children}
      </StyledFlex>
    </InputChoicesContextProvider>
  );
}
